const BASE_URL = "https://akhilam-backend.onrender.com";
export default BASE_URL;